module.exports = __webpack_public_path__ + "img/ad.d4227482.svg";